{
  "title": "Invite a Judge",
  "description": "Invite a judge to a competition so they can start scoring.",
  "headings": [
    "What You'll Accomplish",
    "Applies to",
    "Before You Start",
    "Where to Go",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "Once finished, the invited judge receives an invitation and can join the competition's judging workflow.",
  "roleNote": "Competition admin",
  "prerequisites": [
    "The competition has been created",
    "You have the judge's email address",
    "The judging round has been configured"
  ],
  "pathLabel": "Organizer console → My Competitions → Judge Invitations & Assignments → Invitations",
  "steps": [
    {
      "title": "1. Open \"Judge Invitations & Assignments\"",
      "description": "From the competition, open \"Judge Invitations & Assignments\" and switch to the \"Invitations\" tab."
    },
    {
      "title": "2. Enter the judge's email",
      "description": "Type the judge's email into the invite field. If no account exists for that email, one is created automatically with a temporary password."
    },
    {
      "title": "3. Send the invitation",
      "description": "Confirm the email is correct, then click \"Send Invitation\". A judge with an existing account sees the invitation on their Overview page after signing in and accepts or declines it; a decline shows as \"Declined\" with the reason in the invitation list, and you can invite them again."
    }
  ],
  "afterward": [
    "The judge appears in the invitation list",
    "Their invitation status shows \"Invited\"",
    "An invitation email is sent (for a new account it explains the temporary-password deadline, that \"Forgot password\" works after it expires, and reminds the judge that the invited mailbox is their sign-in account, so use a regularly checked address such as Gmail); whether it was sent or failed is recorded in the audit log (with no email address), and a failed send does not undo the invitation, so you can use \"Resend\" later"
  ],
  "nextSteps": "Next, go to \"Assignments\" to assign submissions to the judges you've invited.",
  "faq": [
    {
      "q": "The judge didn't receive the invitation email?",
      "a": "Double-check the email address, ask them to check spam, then return to \"Invitations\" to check the invitation status and resend if needed."
    }
  ]
}
